import type { JSX } from "react";
// Sidebar dropdown that switches the display currency.
// Options come from the BE (`/currencies`) via the CurrencyProvider.

import { useCurrency } from "../contexts/currency/index.js";
import { NativeSelect } from "./ui/native-select.js";

export function CurrencySelector(): JSX.Element | null {
  const { currencies, selected, setSelected } = useCurrency();
  if (currencies.length === 0) return null;
  return (
    <NativeSelect
      value={selected}
      onChange={(e) => {
        setSelected(e.target.value);
      }}
      aria-label="Display currency"
      className="h-8 text-xs"
    >
      {currencies.map((c) => (
        <option key={c.code} value={c.code}>
          {c.code}
        </option>
      ))}
    </NativeSelect>
  );
}
